import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_kvFfWmOs3D4D: {
	id: 'prd_kvFfW2DEV2mOs3D4D'
	ident: 'prd_kvFfWmOs3D4D'
	sku: 'simple_premium_3m_19_99_3m_79_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'month'
			interval_duration: 3
			iteration_count: 1
			price_id: 'prc_2wZmO2DEV2SCXF7o9'
			amount: 79
			amount_usd: 19.99
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 19.99
			discount: 59.01
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'month'
			interval_duration: 3
			iteration_count: null
			price_id: 'prc_CG4VE2DEV2G5xtxkY'
			amount: 79
			amount_usd: 79
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_kvFfWmOs3D4D, SubscriptionProduct>
const prd_kvFfWmOs3D4D = { ident: 'prd_kvFfWmOs3D4D' } as typeof _prd_kvFfWmOs3D4D

export default prd_kvFfWmOs3D4D
